/**
 * @owner @Appboy/whats-app
 */
import { z } from "zod";
import { whatsAppCommerceDataSchema } from "@schemas/message/whatsAppCommerceDataSchema";
import { whatsAppResponseMessageCommonSchema } from "@schemas/message/whatsAppResponseMessageCommonSchema";

// Refer to WhatsAppResponseMessageMultiProductExport
export const whatsAppResponseMultiProductMessageSchema = z.object({
  ...whatsAppResponseMessageCommonSchema.shape,
  layout: z.literal("multi-product"),
  header_text: z.string().nullable().optional(),
  body: z.string().nullable().optional(),
  footer: z.string().nullable().optional(),
  commerce_data: whatsAppCommerceDataSchema,
});
